import { PrivacyPolicy } from "../components/pages/additionalPages/privacyPolicy/PrivacyPolicy";

export function PrivacyPolicyPage(){

    return(
        <>
            <PrivacyPolicy />
        </>
    );
}